"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionFullFragmentDoc = void 0;
const client_1 = require("@apollo/client");
exports.RegionFullFragmentDoc = client_1.gql `
    fragment RegionFull on Region {
  Id
  Name
  SupportEmail
  EcoTaxiNumber
  EcoTaxiAbout
}
    `;
//# sourceMappingURL=Region.generated.js.map